// components/layout/UpdatePrompt.tsx — Prompts the user to reload when a new
// service worker (i.e. a new deploy) is waiting, so installed PWAs and
// long-lived browser tabs actually pick up new releases.

import { useRegisterSW } from 'virtual:pwa-register/react';
import styles from './UpdatePrompt.module.css';

export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      // Poll for a new service worker periodically, since the browser only
      // checks for updates on navigation/page load by default — long-lived
      // installed PWA sessions would otherwise never notice a new deploy.
      if (!registration) return;
      setInterval(() => {
        registration.update();
      }, 60 * 60 * 1000); // hourly
    },
  });

  if (!needRefresh) return null;

  return (
    <div className={styles.banner} role="status" aria-live="polite">
      <span className={styles.text}>A new version is available.</span>
      <button
        type="button"
        className={styles.reloadBtn}
        onClick={() => updateServiceWorker(true)}
      >
        Reload
      </button>
      <button
        type="button"
        className={styles.dismissBtn}
        aria-label="Dismiss"
        onClick={() => setNeedRefresh(false)}
      >
        ✕
      </button>
    </div>
  );
}
